(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('simple-product-addons')) {
  class SimpleProductAddons extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;

      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;

      this.addEventListener('change', () => {
        this.sync();
      }, { signal });

      this.querySelector('[data-spa-reset]')?.addEventListener('click', () => {
        this.querySelectorAll('[data-spa-choice]').forEach(input => {
          input.checked = false;
        });

        this.querySelectorAll('details.spa-accordion').forEach(details => {
          if (!details.classList.contains('spa-always-open')) {
            details.open = false;
          }
        });

        this.sync();
      }, { signal });

      this.form.addEventListener('click', event => {
        const button = event.target.closest('[ref="addToCartButton"]');

        if (!button) return;
        if (!this.selected().length) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        this.addSelected();
      }, {
        capture: true,
        signal
      });

      this.form.addEventListener('submit', event => {
        if (!this.selected().length) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        this.addSelected();
      }, {
        capture: true,
        signal
      });

      this.sync();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.form?.classList.remove('spa-has-extras');
    }

    selected() {
      return [
        ...this.querySelectorAll(
          '[data-spa-choice]:checked:not(:disabled)'
        )
      ];
    }

    sync() {
      if (!this.form) return;

      this.form.classList.toggle(
        'spa-has-extras',
        this.selected().length > 0
      );
    }

    async addSelected() {
      if (this.busy || this.uncertain) return;
      if (!this.form || !this.form.reportValidity()) return;

      const button =
        this.form.querySelector('[ref="addToCartButton"]');

      if (button?.disabled) return;

      const formData = new FormData(this.form);

      const mainVariantId = formData.get('id');

      if (!mainVariantId) return;

      const quantity =
        Number(formData.get('quantity') || 1);

      if (
        !Number.isInteger(quantity) ||
        quantity < 1
      ) return;

      const mainProperties = {};

      for (const [key, value] of formData.entries()) {
        const match =
          key.match(/^properties\[(.*)\]$/);

        if (
          match &&
          typeof value === 'string' &&
          value.trim()
        ) {
          mainProperties[match[1]] =
            value.trim();
        }
      }

      const group =
        globalThis.crypto?.randomUUID?.() ||
        `${Date.now()}-${Math.random()
          .toString(36)
          .slice(2)}`;

      mainProperties._addon_group = group;

      const mainItem = {
        id: String(mainVariantId),
        quantity: quantity,
        properties: mainProperties
      };

      if (formData.get('selling_plan')) {
        mainItem.selling_plan =
          formData.get('selling_plan');
      }

      const addonItems =
        this.selected().map(input => ({
          id: String(input.dataset.id),
          quantity: quantity,
          properties: {
            _addon_group: group,
            'For product':
              this.dataset.productTitle
          }
        }));

      const items = [
        mainItem,
        ...addonItems
      ];

      const error =
        this.querySelector('.spa-error');

      const cartLink =
        this.querySelector('.spa-check-cart');

      if (error) error.hidden = true;
      if (cartLink) cartLink.hidden = true;

      this.busy = true;
      this.setAttribute('aria-busy', 'true');

      if (button) {
        button.setAttribute('aria-disabled', 'true');
      }

      try {
        const response = await fetch(
          this.dataset.addUrl,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: items
            })
          }
        );

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(
            typeof data.description === 'string'
              ? data.description
              : 'Unable to add products to cart.'
          );
        }

        window.location.assign(
          this.dataset.cartUrl
        );

      } catch (err) {
        this.busy = false;
        this.uncertain = false;

        this.removeAttribute('aria-busy');

        if (button) {
          button.removeAttribute('aria-disabled');
        }

        if (error) {
          error.textContent =
            err.message ||
            this.dataset.error;

          error.hidden = false;

          error.scrollIntoView({
            block: 'nearest'
          });
        }

        if (cartLink) {
          cartLink.hidden = false;
        }
      }
    }
  }

  customElements.define(
    'simple-product-addons',
    SimpleProductAddons
  );
}
  } catch(e) { console.error(e); }
})();

})();
